import React from 'react';
import { Button } from '../../../common-components/Button/Button';
import { strings } from '../../../resources/strings';

interface IActionsForOrdersInTransportSelectionProps {
    filtering?: boolean;
    appliedFilters?: number;
    updateList?: () => void;
    filterList?: () => void;
    clearFilter?: () => void;
}

const ActionsForOrdersInTransportSelection: React.FC<IActionsForOrdersInTransportSelectionProps> = ({
    filtering,
    appliedFilters,
    updateList,
    filterList,
    clearFilter,
}) => {

    return (
        <>
            { appliedFilters ?
                <Button text={strings.ClearFilter} disabled={filtering} marginRight={'3px'} marginLeft={'3px'} minWidth={'140px'} click={clearFilter} /> 
            : null }

            <Button text={strings.Filter} disabled={filtering} marginRight={'3px'} marginLeft={'3px'} minWidth={'140px'} click={filterList} /> 

            <Button text={strings.UpdateList} disabled={filtering} marginRight={'3px'} marginLeft={'3px'} minWidth={'140px'} click={updateList} /> 
        </>
    );
}

export {ActionsForOrdersInTransportSelection};